import React, { useEffect, useState, useRef } from "react";
import ContractViewer from "../components/ContractViewer";
// import { contractFormat } from "../components/ContractFormat";
import "../style/ContractForm.css";
import "../style/OathForm.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { apiKey } from "../config/config";
import AjlSaleContractStyled from "../components/AjlSaleContractStyled";
import { toArabicWord } from "number-to-arabic-words/dist/index-node.js";
// import AjlSaleContract from "../components/AjlSaleContract";

function ContractForm({ lang, data, officeData, logo }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div className="row pt-3">
        <div className="rr col-9">{lang.Contract || "Contract"}</div>
      </div>
      <div className="row">
        <div className="col-9"></div>
        <div className="col-3">
          <div></div>
          <div>
            <button
              type="button"
              // onClick={() => toPDF()}
              onClick={handlePrint}
              className="btn btn-primary"
            >
              {lang.save_contract || "Save Contract"}
            </button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div classNames="d-flex mt-3 mb-3">
          <div
            className="w-100 contarct-form"
            id="contract-form"
            // ref={targetRef}
            ref={componentRef}
          >
            {/* {load && <ContractViewer htmlContent={contractFormat} />} */}
            {data && (
              <AjlSaleContractStyled data={data} officeData={officeData} logo={logo} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function OathForm({ lang, oathFormat }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div className="row pt-3">
        <div className="rr col-9">{lang.oath_form || "Oath Form"}</div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-9"></div>
          <div className="col-3">
            <div></div>
            <div to="/add-customer">
              <button
                type="button"
                // onClick={() => toPDF()}
                onClick={handlePrint}
                className="btn btn-primary"
              >
                <img src="img/fi_plus.png" alt="" className="img-fluid" />
                {lang.save_oath || "Save Oath"}
              </button>
            </div>
          </div>
        </div>
        <div classNames="d-flex">
          <div
            className="w-100 oath-form"
            style={{ padding: "2rem 0" }}
            id="oath-form"
            // ref={targetRef}
            ref={componentRef}
          >
            <ContractViewer htmlContent={oathFormat} />
          </div>
        </div>
      </div>
    </>
  );
}

function PolicyForm({ lang, placeholders }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div className="row pt-3">
        <div className="rr col-9">{lang.policy || "Policy"}</div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-9"></div>
          <div className="col-3">
            <div></div>
            <div>
              <button
                type="button"
                // onClick={() => toPDF()}
                onClick={handlePrint}
                className="btn btn-primary"
              >
                {lang.save_policy || "Save Policy"}
              </button>
            </div>
          </div>
        </div>
        <div classNames="d-flex mt-3 mb-3">
          <div
            className="w-100"
            style={{ padding: "2rem 0" }}
            id="policy-form"
            // ref={targetRef}
            ref={componentRef}
          >
            {placeholders && (
              <div dir="rtl" style={{ padding: "2rem" }}>
                <p
                  style={{
                    fontSize: "1rem",
                    textDecoration: "underline",
                    marginBottom: "3rem",
                  }}
                >
                  الموافقة على شروط استخدام برنامج امان القروض الخاص بإدارة
                  الأقساط
                </p>
                <p style={{ fontSize: "1rem" }}>
                  الإسم : {placeholders.customer_name}
                </p>
                <p style={{ fontSize: "1rem" }}>
                  رقم الهوية : {placeholders.customer_id}
                </p>
                <p style={{ fontSize: "1rem" }}>
                  جوال: {placeholders.customer_phone}
                </p>
                <p style={{ fontSize: "1rem" }}>التوقيع :</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function ContractInformation({ lang, logo }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [load, setLoad] = useState(true);
  const [officeData, setOfficeData] = useState();
  const [placeholders, setPlaceholders] = useState();
  // const [officeName, setOfficeName] = useState("");
  const { customer_id } = useParams();

  function convertDateFormat(inputDate, locale) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    if (locale !== "ar-SA") {
      // Format date as YYYY-MM-DD for English locale
      const year = dateObject.getFullYear();
      const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObject.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    }

    const formattedDate = dateObject.toLocaleDateString(locale, options);
    return formattedDate;
  }

  const oathFormat =
    placeholders &&
    `
  <div style="width: 800px; margin: 0 auto">
  <main style="margin-top: 8rem;
  width: 100%;
  padding: 1rem;
  border: 1px solid black;
  border-radius: 80px;
  z-index: 1;">
  <div class="main">
      <div class="center">
          <button><h1 style="font-size: 16px;" class="fw-semibold">ســــــــنــد لأمــــر </h1></button>
      </div>
  </div>
  <div class="content">
    <div class="content2">
     <div>
              <h3 style="font-size: 16px;">رقم السند: </h3> 
              
          </div>
          <div>
              <h3 style="font-size: 16px; color: red"> \t ${placeholders.contract_form_number || ""
    }        </h3>
          </div>
    </div>
  </div>
  <div class="content">
      <div class="content2">
         
          <div>
              <h3 style="font-size: 16px;">حرر هذا السند في <span>مدينة </span>    ${placeholders.judgement_city || ""
    }        </h3>
          </div>
          <div>
              <h3 id="center" style="font-size: 16px;">بتاريخ: ${convertDateFormat(placeholders.date_contract) || ""
    }</h3>
          </div>
         
          
      </div>
      <div class="content1">
          
          <div class="d-flex">
              <h3 style="color: red; font-size: 16px;">المبلـــــغ: ( ${placeholders.total_value || ""
    } ) <span style="color: black">ريال سعودي</span></h3>
          </div>
      </div>
  </div>

  <div >
      <h3 style="font-size: 16px;">أتعهد أن الموقع أدناه بأن أدفع بموجب هذا السند بدون قيد أو شرط لأمر: </h3>
  </div>

  <div>
      <h3 style="font-size: 16px;">المبلغ الموضح أعلاه. <span style="color: red;"> ${toArabicWord(
      placeholders.total_value || 0
    )} </span> ريال سعودي</h3>
  </div>

  <div>
      <h3 style="font-size: 16px;">المشترى بالآجل والمستحق عند الإطلاع وأن يكون الاختصام المكاني للتنفيذ في مكان اصدار هذا السند</h3>
  </div>

  <div class="next-content">
          <div style='width: 100%;'> <h3 style="font-size: 16px;">اسـم المدين : ${placeholders.customer_name || ""
    }</h3>
          <h3 style="font-size: 16px;"> جوال: ${placeholders.customer_phone
    } </h3></div>
          <div style='width: 100%;'> <h3 style="font-size: 16px;">رقـم الهوية : ${placeholders.customer_id || ""
    }</h3></div>
      
          <div style="width: 100%;"> <h3 style="font-size: 16px;">تاريخ الميلاد : ${convertDateFormat(placeholders.customer_DoB) || ""
    }</h3></div>
  </div>

  <div class="last-content">
   <div><h3 style="font-size: 16px;">توقيع المدين</h3></div>
  </div>

</main>

<div class="bottom">
    <div class="bottom1"><h3 style="font-size: 16px;">
    هذا السند واجب الدفع بدون تعال بموجب قرار مجلس الوزراء الموقر رقم ٦٩٢ بتاريخ ١٣٨٣/٩/٢٦هـ والمتوج بالمرسوم الملكي الكريم رقم ۳۷ بتاريخ ۱۳۸۳/۱۰/۱۱هـ نظام الأوراق التجارية</h3></div>
    <div class="bottom2"><h3 style="font-size: 16px;">بموجب هذا السند يسقط المدين والكفيل الغارم حقوق التقديم والمطالبة والاحتجاج والاخطار بالامتناع عن الوفاء والمتعلقة بهذا السند كما يجوز للمدعي بموجب هذا السند الرجوع للمدين أو الكفيل الغارم منفردين أو مجتمعين ودون مراعاة أو ترتيب</h3></div>
   </div>

</div>
`;

  const shareToWhatsApp = () => {
    const baseUrl = window.location.origin;
    const phoneNo = placeholders.customer_phone.trim(); // Remove spaces
    let contactNumber = "966" + phoneNo.replace(/^0/, ""); // Remove leading zero if exists

    // console.log("Formatted Phone Number:", contactNumber);

    const contractUrl = `${baseUrl}/contract/${customer_id}`;
    const message = `Hello! Here is the contract:\n${contractUrl}`;
    const encodedMessage = encodeURIComponent(message);

    // Test both URLs
    const whatsappUrl1 = `https://wa.me/${contactNumber}?text=${encodedMessage}`;
    // const whatsappUrl2 = `https://api.whatsapp.com/send?phone=${contactNumber}&text=${encodedMessage}`;

    // console.log("Testing wa.me URL:", whatsappUrl1);
    // console.log("Testing api.whatsapp URL:", whatsappUrl2);

    // Try one or both
    window.open(whatsappUrl1, "_blank");
  };

  useEffect(() => {
    axios
      .get(apiKey + "/get-contract-info/" + customer_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // console.log(res.data.result[0])
        if (!res.data.result[0]) {
          setLoad(false);
        }
        setPlaceholders(res.data.result[0]);
        setOfficeData(res.data.dealer);
      })
      .catch((err) => {
        console.error(err);
      });
    // setOfficeName(
    //   JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin)
    //     .branch_name
    // );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  className="sidebaricon"
                  xmlns="http://www.w3.org/2000/svg"
                  height="13"
                  width="15"
                  viewBox="0 0 576 512"
                >
                  <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Customer_Management || "Customer Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.contract || "Contract"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row">
                  <div className="col-9"></div>
                  <div className="col-3">
                    <div></div>
                    <div>
                      <button
                        type="button"
                        onClick={shareToWhatsApp}
                        className="btn btn-success"
                      >
                        {lang.share_to_whatsapp || "Share to WhatsApp"}
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <p style={{ color: "red" }}>
                    {!placeholders && "No Contracts found for this customer"}
                  </p>
                </div>
                <ContractForm
                  lang={lang}
                  load={load}
                  // contractFormat={contractFormat}
                  data={placeholders}
                  officeData={officeData}
                  logo={logo}
                />
                <OathForm lang={lang} oathFormat={oathFormat} />
                <PolicyForm lang={lang} placeholders={placeholders} />
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default ContractInformation;
